export const routeMap = {
  'www.wirkaufendeinauto.at': 'router.wirkaufendeinauto.at',
  'www.wijkopenautos.be': 'router.wijkopenautos.be',
  'www.wirkaufendeinauto.de': 'router.wirkaufendeinauto.de',
  'www.vikoberallebiler.dk': 'router.vikoberallebiler.dk',
  'www.compramostucoche.es': 'router.compramostucoche.es',
  'www.vendezvotrevoiture.be': 'router.vendezvotrevoiture.be',
  'www.vendezvotrevoiture.fr': 'router.vendezvotrevoiture.fr',
  'www.noicompriamoauto.it': 'router.noicompriamoauto.it',
  'www.wijkopenautos.nl': 'router.wijkopenautos.nl',
  'www.kupimytwojsamochod.pl': 'router.kupimytwojsamochod.pl',
  'www.compramososeucarro.pt': 'router.compramososeucarro.pt',
  'www.vikoperdinbil.se': 'router.vikoperdinbil.se',
  'wkfda.at': 'router.wkfda.at',
  'wikoau.be': 'router.wikoau.be',
  'wkda.de': 'router.wkda.de',
  'vkab.dk': 'router.vkab.dk',
  'cotuco.es': 'router.cotuco.es',
  'vevovo.be': 'router.vevovo.be',
  'vevovo.fr': 'router.vevovo.fr',
  'nocoau.it': 'router.nocoau.it',
  'wikoau.nl': 'router.wikoau.nl',
  'cosc.pt': 'router.cosc.pt',
  'vkdb.se': 'router.vkdb.se',
  'frontend-qa-1.auto1-test.com': 'router-qa-1.cfe.auto1-test.com',
  'auto1-test.com': 'router-qa-1.cfe.auto1-test.com',
  'localhost': 'router-qa-1.cfe.auto1-test.com'
};
//# sourceMappingURL=route-map.js.map